// extracted by mini-css-extract-plugin
export default {"GalleryPhoto":"GalleryCard_GalleryPhoto__d178Q","ExpandButton":"GalleryCard_ExpandButton__-VBu9","Expanded":"GalleryCard_Expanded__sPgmK","Close":"GalleryCard_Close__MVkeD"};